export class OneDriveUrlHelper {
    static onedriveUniqueName = "/personal";
    static initialDocumentLibrary = "/Documents";
    static urlStart = "https://"

    static getSiteUrl = (url: string): string => {
        return url?.replace(OneDriveUrlHelper.initialDocumentLibrary, "");
    }

    static getOpenInOneDriveDesktopUrl = (fileId: string, siteId: string, listId: string, userEmail: string, userId: string, webUrl: string, fileName: string): string => {
        // odopen://openFile/
        // ?fileId={83F45FB1-A0A5-4060-9B70-F9B9176903BF}
        // &siteId={db0d4d8f-4bbd-475b-be32-75f362cee55e}
        // &listId={9A0841DB-86B2-497C-A83C-8DE855A2B613}
        // &userEmail=d.devilliers@xblox.net
        // &userId={3e9d6e90-8a38-46a3-a296-0a1e83e6172e}
        // &webUrl=https://xblox.sharepoint.com/sites/XbloxB.V.Demo
        // &fileName=Calculatie.pdf

        return `odopen://openFile/?fileId={${fileId}}&siteId={${siteId}}&listId={${listId}}&userEmail=${userEmail}&userId={${userId}}&webUrl=${webUrl}&fileName=${fileName}`;
    }
}